<a [attr.href]="href || null" 
   [ngClass]="[variant, color, underline]" 
   [attr.aria-label]="ariaLabel"
   [attr.target]="href && target ? target : null"
   [attr.rel]="href && target === '_blank' ? rel : null">
  
  <hyperkit-typography 
     [variant]="variant" 
     color="inherit" 
     [display]="display"
     [class]="underline === 'none' ? 'no-underline' : ''">
    {{ text }}
  </hyperkit-typography>
</a>